<template>
    <div></div>
</template>

<script>
export default {
    name: "Auth",
    created() {
        const accessToken = this.$router.currentRoute.query.accessToken
        const returnUrl = this.$router.currentRoute.query.redirect
        if (accessToken && accessToken.length > 0) {
            this.$store.dispatch('SET_USER_TOKEN', accessToken)
        }
        if (returnUrl && returnUrl.length > 0) {
            window.location.href = returnUrl
        } else {
            window.location.href = '/Rccl.UserCenter/CustomerInfo/Info'
        }
    }
}
</script>

<style lang="less" scoped>

</style>